"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
const resource_1 = __importDefault(require("./Allianz/resource"));
const resource_2 = __importDefault(require("./Audi/resource"));
const resource_3 = __importDefault(require("./VW/resource"));
const resource_4 = __importDefault(require("./Skoda/resource"));
const resource_5 = __importDefault(require("./Seat/resource"));
const resource_6 = __importDefault(require("./Cupra/resource"));
const resourcesHelper = {
    'Allianz': resource_1.default,
    'Audi': resource_2.default,
    'VW': resource_3.default,
    'Skoda': resource_4.default,
    'Seat': resource_5.default,
    'Cupra': resource_6.default
};
const themeResource = ((_a = process.env.REACT_APP_THEME) === null || _a === void 0 ? void 0 : _a.toString()) || "Allianz";
exports.default = resourcesHelper[themeResource];
//# sourceMappingURL=resourcesLoader.js.map